import setLoading from 'components/loading';
import ReactDOMServer from "react-dom/server";
import downloadHtmlExport from './downloadHtmlExport';
import { InspectionsExport } from './inspectionsExport';
import { getCurrentDateTime } from 'utils'


export default {
  'ExportInspections.ExportDropdown': ({ action, startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds, fileName, report }, outlet) => {
    if (action === 'pdf') {
      const html = ReactDOMServer.renderToString(InspectionsExport({ startDate, endDate, inspections, status, searchTerms, properties, groups, selectedPropertyIds, selectedGroupIds, report }));
      setLoading(true);
      const promise = downloadHtmlExport.saveHtml({ html, options: { date: getCurrentDateTime() } });
      promise.then((r) => {
        const source = `data:application/pdf;base64,${r.data}`;
        const link = document.createElement("a");
        link.href = source;
        link.download = `${fileName}.pdf`;
        link.click();
      })
      promise.catch((e) => {
        console.warn(e);
        setError(true);
      });
      promise.finally(() => setLoading(false));
    }
    if (action === 'subscribe') {
      outlet({ action: 'subscribe' })
    }
  },
}
